import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VTabGroupComponent } from './vtab-group/vtab-group.component';
import { VTabComponent } from './vtab/vtab.component';
import { SharedModule } from '@sbd-doug-frontend/app/shared/shared.module';
import { VTabPanelTitleComponent } from './vtab-panel-title/vtab-panel-title.component';
import { VTabActionBarComponent } from './vtab-action-bar/vtab-action-bar.component';
import { VTabRightPanelComponent } from './vtab-right-panel/vtab-right-panel.component';
import { VTabActionTopComponent } from './vtab-action-top/vtab-action-top.component';
import { SettingButtonComponent } from '@sbd-doug-frontend/shared/lib/ui/setting-button/setting-button.component';
import { RouterModule } from '@angular/router';
import { CIPXPrimaryButtonComponent, CIPXCancelButtonComponent, CIPXButtonComponent } from '@sbd-doug-frontend/shared/lib/ui/buttons';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    SettingButtonComponent,
    RouterModule,
    CIPXPrimaryButtonComponent,
    CIPXCancelButtonComponent,
    CIPXButtonComponent
  ],
  exports: [
    VTabGroupComponent,
    VTabComponent,
    VTabPanelTitleComponent,
    VTabActionBarComponent,
    VTabRightPanelComponent,
    VTabActionTopComponent,
    CIPXPrimaryButtonComponent,
    CIPXCancelButtonComponent,
    CIPXButtonComponent
  ],
  declarations: [
    VTabGroupComponent,
    VTabComponent,
    VTabPanelTitleComponent,
    VTabActionBarComponent,
    VTabRightPanelComponent,
    VTabActionTopComponent,
  ],
})
export class VTabModule {}
